import ProjectIndexContainer from './ProjectIndexContainer';
export default ProjectIndexContainer;